module.exports = __webpack_public_path__ + "media/images/demo/profile-picture-mallory-tour-manager--fff93226a753730ae1a914e48f0c2249.jpg";